import { useEffect, useState } from 'react';

export const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState({
    innerWidth: window.innerWidth,
    innerHeight: window.innerHeight,
  });

  const handleWindowSizeChange = () => {
    const { innerWidth, innerHeight } = window;
    setWindowSize({ innerWidth, innerHeight });
  };

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);

    // Unmount
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);

  return windowSize;
};
